var render, staticRenderFns
import script from "./AssessmentChart.vue?vue&type=script&lang=js&"
export * from "./AssessmentChart.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentChart.vue?vue&type=style&index=0&id=12dca8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dca8da",
  null
  
)

component.options.__file = "AssessmentChart.vue"
export default component.exports